import Toggle from "react-toggle"
import "react-toggle/style.css"

export { Toggle }
